import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';
import { Component, computed, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { AuthService } from '../../../auth/auth.service';
import { CompanyService } from '../../../domain/company/company.service';

interface NavItem {
  label: string;
  route: string[];
  iconName: string;
  warning?: boolean;
}

@Component({
  selector: 'app-side-nav-mobile',
  imports: [FeatherModule, RouterLink, RouterLinkActive, TranslateModule],
  templateUrl: './side-nav-mobile.component.html',
  styleUrl: './side-nav-mobile.component.scss',
})
export class SideNavMobileComponent {
  private authService = inject(AuthService);
  private companyService = inject(CompanyService);

  navItems = computed<NavItem[]>(() => {
    const isAuthenticated = this.authService.isAuthenticated();

    if (!isAuthenticated) {
      return [];
    }

    return [
      {
        label: 'pending-requests',
        route: ['/pending-requests'],
        iconName: 'clock',
        warning: this.companyService.pendingCount() > 0,
      },
      {
        label: 'companies',
        route: ['/companies'],
        iconName: 'briefcase',
      },
      // {
      //   label: 'users',
      //   route: ['/users'],
      //   iconName: 'users',
      // },
      // {
      //   label: 'resources-guidance',
      //   route: ['/resources'],
      //   iconName: 'book',
      // },
    ];
  });
}
